import { useQuery } from '@tanstack/solid-query'
import { getServiceClient } from '~/lib/api'

type UnlockedTreeEntry = {
  gid: number
  unlocked_at: string
}

export const unlockedTreesKey = ['unlocked-trees'] as const

// Backs the tree-ownership deeplink gate (~/lib/tree-ownership-gate, ADR
// 0025). `enabled` keeps this lazy: no tree-scoped deeplink card, no request.
export function useUnlockedTreesQuery(enabled: () => boolean) {
  return useQuery(() => ({
    queryKey: unlockedTreesKey,
    enabled: enabled(),
    // Override the global retry: false — the gate fails closed and staleTime
    // is Infinity, so without retries one network blip would hide the arrow
    // from an owning user for the rest of the session.
    retry: 2,
    queryFn: async () => {
      const { client } = await getServiceClient()
      const entries = await client
        .get('user/tree_types/unlocked_timestamps')
        .json<UnlockedTreeEntry[]>()
      return new Set((entries ?? []).map((entry) => entry.gid))
    },
  }))
}
